import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XCurrencyPipe } from './xCurrency.pipe';
import { HasPermissionPipe } from './has-permission.pipe';
import { XUserPipe } from './x-user.pipe';
import { XTranslateKeyPipe } from './x-translate-key.pipe';
import { XValidatePipe } from './x-validate.pipe';

@NgModule({
  declarations: [
    XCurrencyPipe,
    HasPermissionPipe,
    XUserPipe,
    XTranslateKeyPipe,
    XValidatePipe
  ],
  imports: [
    CommonModule
  ], 
  exports: [
    XCurrencyPipe,
    HasPermissionPipe,
    XUserPipe,
    XTranslateKeyPipe,
    XValidatePipe
  ]
})
export class PipesModule { }
